import React, { ChangeEvent} from "react";
import { CONSTANTS } from "../../constants/Constants";
import Input from "../Inputs/index";
import Modal from "../Modal";
import Textarea from "../Textarea";
import Select from "../Select";

interface ModalProps {
  setIsModalOpen: any;
  payload: any;
  quesChangeHandler: (e: ChangeEvent) => void;
  saveQuesHandler: ()=>void
}
const QuestionsModal: React.FC<ModalProps> = ({
  setIsModalOpen,
  payload,
  quesChangeHandler,
  saveQuesHandler
}) => {
  
  return (
    <div>
      <Modal
        save_handler={saveQuesHandler}
        modal_handler={setIsModalOpen}
        modal_title={CONSTANTS.MODIFY_QNA}
      >
        <div className="flex flex-col mb-4">
          <label className="mb-1 text-sm">
            {CONSTANTS.QUESTION_TXT}
            <span className="text-error mr-1">*</span>
          </label>
          <Input
            input_name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.QUESTION}
            value={payload[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.QUESTION]}
            change_handler={quesChangeHandler}
            placeholder="Type question"
            other_classes="text-sm h-[36px]"
          />
        </div>

        <div className="flex flex-col mb-4">
          <label className="mb-1 text-sm">
            {CONSTANTS.ANSWER_TXT}
            <span className="text-error mr-1">*</span>
          </label>
          <Textarea
            name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ANSWER}
            placeholder={CONSTANTS.DESCRIPTION_TXT}
            change_handler={quesChangeHandler}
            value={payload[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ANSWER]}
            other_classes="text-sm h-20 border border-[#E6E6E6] rounded focus:outline-none"
          />
        </div>

        <div className="flex flex-col mb-4">
          <label className="mb-1 text-sm">
            {CONSTANTS.SHOW_ON_PROFILE_TXT}
          </label>
          <Select
            value={payload?.status}
            name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS}
            handle_change={quesChangeHandler}
            options={[
              { id: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(), name: CONSTANTS.YES_TXT },
              { id: CONSTANTS.DISABLED_TXT.toLocaleUpperCase(), name: CONSTANTS.NO_TXT },
            ]}
            other_classes="text-sm h-[36px] rounded-md"

          />
        </div>
      </Modal>
    </div>
  );
};

export default QuestionsModal;
